import { render, staticRenderFns } from "./auctionPackageCurrencyForm.vue?vue&type=template&id=71f61ce2&lang=pug"
import script from "./auctionPackageCurrencyForm.vue?vue&type=script&lang=js"
export * from "./auctionPackageCurrencyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports